import { useState, useEffect } from "react";
import * as Account from '../account';

export default function ServiceStatus({
    platform,
    selectedModel,
    foraWorks,
    foraCompany,
    account,
    csvFile,
    QBDCompany,
    QBOCompany,
    checkForaWorks,
}) {
    const [isOpen, setIsOpen] = useState(true);
    const [selectedPlatform, setSelectedPlatform] = useState(
        platform
            ? platform
            : new URLSearchParams(window.location.search).get("platform") || localStorage.getItem("selected_platform") || "quickbooks_online"
    );

    // Keep dropdown + status rows in sync when parent passes platform (e.g. Home main select).
    useEffect(() => {
        if (platform) {
            setSelectedPlatform(platform);
        }
    }, [platform]);

    const foraLabel =
        foraCompany?.name
            ? `Fora : "${foraCompany.name}"`
            : account?.user
                ? `Fora : "${account.user.Name}"`
                : "Fora";

    const StatusRow = ({ ok, label, action }) => (
        <div className={`flex items-center space-x-2 ml-2 text-xs font-semibold ${action ? 'cursor-pointer' : null}`} onClick={_ => { if (action) action() }}>
            <span className={ok ? "text-green-600 font-bold" : "text-red-600 font-bold"}>
                {ok ? "✓" : "✗"}
            </span>
            <span>{label}</span>
        </div>
    );

    const handleOptionChange = (e) => {
        const value = e.target.value;
        setSelectedPlatform(value);
        localStorage.setItem("selected_platform", value);

        // Reload page with query string
        const url = new URL(window.location.href);
        url.searchParams.set("platform", value);
        window.location.href = url.toString();
    };

    /** Sign out clears only the Fora Connector session. QuickBooks Online OAuth stays linked until the user disconnects from QuickBooks on the dashboard. */
    const handleSignOut = () => {
        window.location.href = "/signout";
    };

    return (
        <div className="fixed top-4 right-4 bg-gray-50 border border-gray-200 rounded-xl shadow-lg w-64 z-50">
            {/* Header with Close and Expand */}
            <div onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center bg-gray-200 rounded-xl cursor-pointer">
                <span className="font-bold ml-4">{Account.getUserAccount() && Account.getUserAccount().user && Account.getUserAccount().user.Name}</span>
                <div className="flex mr-4">
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-gray-600 hover:text-gray-800 font-bold text-3xl"
                    >
                        {isOpen ? "–" : "+"}
                    </button>
                </div>
            </div>

            {isOpen && (
                <div className="p-4 space-y-2">
                    {/* Platform Selector */}
                    <div className="mb-3">
                        <p className="font-bold mb-1">Select Platform</p>
                        <div className="relative w-full">
                            <select
                                name="platform"
                                value={selectedPlatform}
                                onChange={handleOptionChange}
                                className="w-full appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-2 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                            >
                                <option value="quickbooks_online">QuickBooks Online</option>
                                <option value="quickbooks_desktop">QuickBooks Desktop</option>
                                <option value="csv">CSV</option>
                            </select>
                            <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-600">
                                ▼
                            </span>
                        </div>
                    </div>
                    <p className="font-bold mb-1">Platform status</p>
                    {/* Status Rows */}
                    <StatusRow ok={foraWorks} label={foraLabel} action={checkForaWorks} />
                    {selectedPlatform === "csv" && selectedModel !== "order" && (
                        <StatusRow ok={!!csvFile} label={"CSV : " + (csvFile || "No CSV")} />
                    )}
                    {selectedPlatform === "quickbooks_desktop" && (
                        <StatusRow
                            ok={!!QBDCompany}
                            label={QBDCompany ? `QuickBooks Desktop : "${QBDCompany.companyName}"` : "QuickBooks Desktop"}
                        />
                    )}
                    {selectedPlatform === "quickbooks_online" && (
                        <StatusRow
                            ok={!!QBOCompany}
                            label={QBOCompany ? `QuickBooks Online : "${QBOCompany.CompanyName}"` : "QuickBooks Online"}
                        />
                    )}

                    {Account.getUserAccount() && Account.getUserAccount().user ?
                        <div className="flex items-center">
                            <button
                                type="button"
                                className="text-red-500 border-2 border-red-500 rounded-lg font-bold p-1 m-2 w-full"
                                onClick={handleSignOut}
                            >
                                Sign out
                            </button>
                        </div> : null}
                </div>
            )}
        </div>
    );
}
